import { render } from "./Modal.vue?vue&type=template&id=64f7dca9"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "64f7dca9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64f7dca9', script)) {
    api.reload('64f7dca9', script)
  }
  
  module.hot.accept("./Modal.vue?vue&type=template&id=64f7dca9", () => {
    api.rerender('64f7dca9', render)
  })

}

script.__file = "resources/js/Jetstream/Modal.vue"

export default script